import ChainObject from "./ChainObject";
import ChainSource from "./ChainSource";
import InfoBar from "./InfoBar";
import InfoBarHeader from "./InfoBarHeader";
import InfoBarHeaderMenu from "./InfoBarHeaderMenu";
import Menu from "./Menu";
import Modal from "./Modal";
import ReferencePoint from "./ReferencePoint";
import AddSource from "./AddSource";
import AppendSource from "./AppendSource";
import _ from "lodash";

export default class ChainContainer extends React.Component {
  constructor(props) {
    super(props);
    this.equalHeight = this.equalHeight.bind(this);
    this.afterFetchForm = this.afterFetchForm.bind(this);
    this.beforeFetchForm = this.beforeFetchForm.bind(this);
    this.deleteObject = this.deleteObject.bind(this);
    this.deleteEndPoint = this.deleteEndPoint.bind(this);
    this.performDeleteObject = this.performDeleteObject.bind(this);
    this.showDeleteModal = this.showDeleteModal.bind(this);
    this.deleteChain = this.deleteChain.bind(this);
    this.performDeleteChain = this.performDeleteChain.bind(this);
    this.fetchEditForm = this.fetchEditForm.bind(this);
    this.editFormInfoBar = this.editFormInfoBar.bind(this);
    this.createChain = this.createChain.bind(this);
    this.addSource = this.addSource.bind(this);
    this.appendSource = this.appendSource.bind(this);
    this.fetchChainForm = this.fetchChainForm.bind(this);
    this.selectNewObjectType = this.selectNewObjectType.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.selectedChainIsPersonalOpinion = this.selectedChainIsPersonalOpinion.bind(
      this
    );
    this.objectInfoOfSelectedObject = this.objectInfoOfSelectedObject.bind(
      this
    );
    this.doesSelectedObjectExist = this.doesSelectedObjectExist.bind(this);
    this.setIsExpandedFlag = this.setIsExpandedFlag.bind(this);
    this.horizontalArrowClick = this.horizontalArrowClick.bind(this);
    this.setSelectedObject = this.setSelectedObject.bind(this);
    this.changeLogOfSelectedObject = this.changeLogOfSelectedObject.bind(this);
    this.toggleSelectedObject = this.toggleSelectedObject.bind(this);
    this.sortReferencesForTopAndBottomArrow = this.sortReferencesForTopAndBottomArrow.bind(
      this
    );
    this.saveAsFavorite = this.saveAsFavorite.bind(this);
    this.generateChainObject = this.generateChainObject.bind(this);
    this.contentBoxClicked = this.contentBoxClicked.bind(this);
    this.showLeftBar = this.showLeftBar.bind(this);
    this.referencePointMouseLeave = this.referencePointMouseLeave.bind(this);
    this.referencePointMouseEnter = this.referencePointMouseEnter.bind(this);
    this.toggleModalCloseIcon = this.toggleModalCloseIcon.bind(this);
    this.setChainContainerState = this.setChainContainerState.bind(this);
    this.hideFormFields = this.hideFormFields.bind(this);
    globalFunctions.sortReferencesForTopAndBottomArrow = this.sortReferencesForTopAndBottomArrow;
    this.dataI18nKeys = [
      "create-chain",
      "source-are-you-sure",
      "source-delete-object",
      "source-add-source",
      "source-reference",
      "source-add-chain",
      "source-select-type",
      "source-delete-warning",
      "source-delete-reference-header",
      "source-delete-reference-extra-message",
      "source-append-source",
      "source-delete-endpoint-extra-message",
    ];
    this.createChainButton = (
      <button
        data-i18n={this.dataI18nKeys[0]}
        className="ui labeled icon button primary-btn positive create-chain basic"
        onClick={this.createChain}
      >
        <i className="add icon" />
        {globalFunctions.getTranslatedMessage(
          this.dataI18nKeys[0],
          this.dataI18nKeys[0]
        )}
      </button>
    );
    this.initLeftBar = { show: false, color: "", viewId: "" };
    this.refPoints = [];
    this.state = {
      selectedObject: null,
      showModal: false,
      modalHeader: "",
      modalContent: null,
      modalFooter: "",
      hideModalCloseIcon: false,
      hideShareButton: true,
      url: "",
      leftBar: this.initLeftBar,
      sourceCurrentInfoData: "",
      isSourceExpanded: false,
      isReferenceNumberExpanded: false,
      isReferenceExpanded: false,
      archiveURL: ""
    };
  }

  componentDidMount() {
    globalFunctions.toggleSelectedObject = (direction) =>
      this.toggleSelectedObject(direction);
    globalFunctions.referencePointIds = globalFunctions.sortReferencesForTopAndBottomArrow();
    globalFunctions.toggleChainModal = (
      value,
      header = "",
      content = null,
      footer = ""
    ) => this.toggleModal(value, header, content, footer);
    globalFunctions.toggleChainModalCloseIcon = (value) =>
      this.toggleModalCloseIcon(value);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    var prevChains = prevProps.object.chains;
    var prevRefPoints = prevProps.object.referencePoint;
    var currentChains = this.props.object.chains;
    var currentRefPoints = this.props.object.referencePoint;
    var elementId, element;
    const { showModal, modalHeader, modalContent } = this.state;
    var selectRefPoint = false;
    globalFunctions.referencePointIds = globalFunctions.sortReferencesForTopAndBottomArrow();
    if (JSON.stringify(currentRefPoints) !== JSON.stringify(prevRefPoints)) {
      // ref points don't match
      selectRefPoint = true;
      if (currentRefPoints.length > prevRefPoints.length) {
        // a new reference has been added
        var newRef = currentRefPoints.slice().pop();
        elementId = newRef.viewId;
        element = document.getElementById(elementId);
      } else if (currentRefPoints.length === prevRefPoints.length) {
        // a reference has been edited
        var refIndex = -1;
        currentRefPoints.some(function (value, index) {
          if (!_.isEqual(value, prevRefPoints[index])) {
            refIndex = index;
            return true;
          }
        });
        elementId = currentRefPoints[refIndex].viewId;
        element = document.getElementById(elementId);
      }
    } else if (JSON.stringify(prevChains) !== JSON.stringify(currentChains)) {
      // chains have been changed
      var refIndex = -1;
      var newSource = null;
      currentChains.some(function (value, index) {
        var prevSources = prevChains[index].sources;
        var sources = value.sources;
        if (!_.isEqual(value.sources, prevChains[index].sources)) {
          if (sources.length < prevSources.length) {
            // a source has been deleted
            selectRefPoint = true;
            // console.log("a source is deleted");
          } else if (sources.length > prevSources.length) {
            // a new source is added
            // console.log("a new source is added", sources[sources.length - 1]);
            newSource = sources[sources.length - 1];
          } else {
            // a source is edited
            sources.every((source, i) => {
              if (!_.isEqual(source, prevSources[i])) {
                newSource = source;
                return false;
              }
              return true;
            });
            // console.log("a source is edited", newSource);
          }
          refIndex = index;
          return true;
        }
      });
      if (newSource) {
        this.setSelectedObject({
          viewId: newSource.viewId,
          id: newSource.id,
          type: globalFunctions.objectTypes.SOURCE,
        });
      }
      elementId = currentRefPoints[refIndex].viewId;
      element = document.getElementById(elementId);
    }

    setTimeout(() => {
      globalFunctions.scrollReferencePointIntoView(
        element,
        elementId,
        selectRefPoint
      );
    }, 500);

    if (this.state.selectedObject) {
      // there is a selected object
      if (!this.doesSelectedObjectExist()) {
        // selected object does not exist
        this.setSelectedObject(null); // empty the selected object
        this.setState((state) =>( {
          isReferenceExpanded : false,
          isReferenceNumberExpanded : false,
          isSourceExpanded : false
        }));
      }
    }
  }

  sortReferencesForTopAndBottomArrow() {
    return this.refPoints.map((refPoint) => refPoint.viewId);
  }
  
  setIsExpandedFlag(object) {
    switch (object) {
      case globalFunctions.objectTypes.SOURCE:
        this.setState((state) => ({
          isSourceExpanded : true
        }));
      case globalFunctions.objectTypes.REFERENCE_NO:
        this.setState((state) => ({
          isReferenceNumberExpanded : true
        }));
      case globalFunctions.objectTypes.REFERENCE:
        this.setState((state) =>( {
          isReferenceExpanded : true
        }));
    }
    return false;
  }

  // this function checks whether or not a selected object on componentDidUpdate
  // exists or not as it's possible that the selected object has been deleted and the state does not
  // reflect this thing
  doesSelectedObjectExist() {
    const id = this.getSelectedObject("id");

    switch (this.getSelectedObject("type")) {
      case globalFunctions.objectTypes.OBJECT:
        return id === this.props.object.id;
      case globalFunctions.objectTypes.SOURCE:
        return this.props.object.chains.some((c) =>
          c.sources.some((s) => s.id === id)
        );
      case globalFunctions.objectTypes.REFERENCE_NO:
      case globalFunctions.objectTypes.OPEN_POINT:
      case globalFunctions.objectTypes.END_POINT:
      case globalFunctions.objectTypes.REFERENCE:
        return this.props.object.referencePoint.some(
          (refPoint) => refPoint.refId === id
        );
    }

    return false;
  }

  setSelectedObject(object) {
    $('.selected-wrap.object-div.main-object.inner-line').addClass('selected');
    $('.selected-wrap.object-div.main-object.inner-line .selected-source').show();
    $('.selected-wrap.link-div.inner-line').addClass('selected');
    $('.selected-wrap.link-div.inner-line .selected-source').show();

    $('.four.wide.column.chain-source').addClass('expanded');
    $('.four.wide.column.chain-source .selected-source').show();
    $('.four.wide.column.chain-source.is_protected').removeClass('expanded');
      // $('.detail-block').removeClass('hide');
      // $('.detail-block').addClass('show');
      // $('.detail-block').show();
    // var vId = this.props.object.viewId;
    // var vId = $('.selected-wrap.reference-block.inner-line').attr('id');
        // $(".detail-block").removeClass('hide');
        // $(".detail-block").addClass('show');
        // $('.selected-wrap.link-div.inner-line i').replaceWith('<span>hp</span>');

    $('#objectIdSpan').show();
    $('#selected-object-id i.dropdown.icon').show();
    this.setState({
      selectedObject: object,
      sourceTypeId: _.get(object, "sourceTypeId", null),
    });

    if (
      object &&
      (object.type === globalFunctions.objectTypes.REFERENCE ||
        object.type === globalFunctions.objectTypes.REFERENCE_NO)
    ) {
      // enable top and bottom arrows only when the selected object is a reference
      globalFunctions.disableTopAndBottomArrows(false, false);
    } else {
      // disable top and bottom arrows when the selected object is not a reference
      globalFunctions.disableTopAndBottomArrows(true, true);
    }

    if (object) {
      // enable left and right arrows when any object is selected
      let stateSelectedObjectViewId = _.get(
        this.state,
        "selectedObject.viewId",
        null
      );
      if (stateSelectedObjectViewId !== object.viewId) {
        this.setState({ sourceCurrentInfo: null });
      }
      var leftDisable = object.type === globalFunctions.objectTypes.OBJECT;
      var isLastSource = false,
        noSourceInChain = false;
      var objects = this.props.object;
      if (object.type === globalFunctions.objectTypes.SOURCE) {
        var selectedRef = this.refPoints.filter(
          (ref) => ref.viewId == object.viewId.substring(0, 12)
        )[0];
        if(selectedRef) {
          var sourceLength = objects.chains[selectedRef.originalIndex].sources.length;
          var lastSourceViewId = objects.chains[selectedRef.originalIndex].sources[sourceLength-1].viewId;
          if (object.viewId == lastSourceViewId && selectedRef.ref_chain_status == 0) {
            isLastSource = true;
          }
        }
      } else if (
        object.type === globalFunctions.objectTypes.REFERENCE ||
        object.type === globalFunctions.objectTypes.REFERENCE_NO
      ) {
        var selectedRef = this.refPoints.filter(
          (refPoint) => object.id === refPoint.refId
        );
        var indexOfChain = selectedRef[0].originalIndex;
        noSourceInChain = objects.chains[indexOfChain].sources.length === 0;
      }
       else if (
        object.type === globalFunctions.objectTypes.REFERENCE ||
        object.type === globalFunctions.objectTypes.REFERENCE_NO
      ) {
        var selectedRef = this.refPoints.filter(
          (refPoint) => object.id === refPoint.refId
        );
        var indexOfChain = selectedRef[0].originalIndex;
        noSourceInChain = objects.chains[indexOfChain].sources.length === 0;
      }
      else if (
        object.type === globalFunctions.objectTypes.END_POINT ||
        object.type === globalFunctions.objectTypes.OPEN_POINT
      ) {
        noSourceInChain = true;
      }
      globalFunctions.disableLeftAndRightArrows(
        leftDisable,
        isLastSource || noSourceInChain
      );
    } else {
      window.history.replaceState(window.location.href,'ObjURL',this.props.object.viewId);
      // disable left and right arrows when no object is selected
      globalFunctions.disableLeftAndRightArrows(true, true);
    }
  }

  //if direction is true select next else select previous
  toggleSelectedObject(direction) {
    var selectedObject = this.state.selectedObject;
    var _setSelectedObject = (viewId, id, sourceTypeId, isProtected, type) =>
      this.setSelectedObject({ viewId, id, sourceTypeId, isProtected, type });
    var OBJECT_TYPE = globalFunctions.objectTypes.OBJECT;
    var END_POINT_TYPE = globalFunctions.objectTypes.END_POINT;
    var OPEN_POINT_TYPE = globalFunctions.objectTypes.OPEN_POINT;
    var REFERENCE_TYPE = globalFunctions.objectTypes.REFERENCE;
    var REFERENCE_NO_TYPE = globalFunctions.objectTypes.REFERENCE_NO;
    var SOURCE_TYPE = globalFunctions.objectTypes.SOURCE;
    var chainObjectElement = document.getElementById("chain-object");

    switch (selectedObject.type) {
      case OBJECT_TYPE:
        var refPoint = this.refPoints.slice(0, 1)[0]; //get top element
        if (direction) {
          // select first reference, this function is defined in ReferencePoint
          globalFunctions.updateReferencePoint[refPoint.viewId]();
        } // if direction is false do nothing
        break;
      case REFERENCE_TYPE:
        if (direction) {
          // var refPoint = this.refPoints.slice(0, 1)[0];
          var refPoint = selectedObject;
          globalFunctions.updateReferencePoint[refPoint.viewId](true);
        } else {
          // select main object
          _setSelectedObject(
            this.props.object.viewId,
            this.props.object.id,
            this.props.object.typeId,
            _.get(this.props.object, "sourceData.Is Protected", "no"),
            OBJECT_TYPE
          );
          globalFunctions.scrollReferencePointIntoView(
            chainObjectElement,
            "chain-object",
            false
          );
        }
        break;
      case REFERENCE_NO_TYPE:
        if (direction) {
          // select first source in chain
          var selectedRef = this.refPoints.filter(
            (ref) => ref.refId === selectedObject.id
          )[0];
          var originalIndex = selectedRef.originalIndex;
          var chains = this.props.object.chains[originalIndex];
          // there's a possibility that the chain is empty in which case do nothing
          if (chains.sources.length === 0) {
            return;
          }
          var firstSourceInChain = chains.sources[0];
          _setSelectedObject(
            firstSourceInChain.viewId,
            firstSourceInChain.id,
            firstSourceInChain.typeId,
            _.get(firstSourceInChain, "sourceData.Is Protected", "no"),
            SOURCE_TYPE
          );
        } else {
          // var refPoint = this.refPoints.slice(0, 1)[0];
          var refPoint = selectedObject;
          // select main object
          globalFunctions.updateReferencePoint[refPoint.viewId]();
        }
        break;
      case SOURCE_TYPE:
        var chains = this.props.object.chains;
        var currentChainIndex = -1;
        var currentChain = chains.filter((c, i) => {
          var selectedSource = c.sources.filter(
            (s) => s.id === selectedObject.id
          );
          if (selectedSource.length === 1) {
            currentChainIndex = i;
            return true;
          }
        });
        var nextIndex = -1;
        var sources = currentChain[0].sources;
        if (direction) {
          // select next source
          sources.some((source, index) => {
            if (source.id === selectedObject.id) {
              nextIndex = index + 1;
              return true;
            }
          });
          if (nextIndex !== -1 && nextIndex < sources.length) {
            var nextSource = sources[nextIndex];
            _setSelectedObject(
              nextSource.viewId,
              nextSource.id,
              nextSource.typeId,
              _.get(nextSource, "sourceData.Is Protected", "no"),
              SOURCE_TYPE
            );
          }
          else {
            var selectedRef = this.refPoints.filter(
              (ref) => ref.viewId == selectedObject.viewId.substring(0, 11)
            )[0];
            var type = selectedRef.ref_chain_status == 1 ? 
              globalFunctions.objectTypes.OPEN_POINT : 
              globalFunctions.objectTypes.END_POINT;
            var lastSourceViewId = chains[currentChainIndex].sources[chains[currentChainIndex].sources.length - 1].viewId;
            _setSelectedObject(
              lastSourceViewId,
              selectedRef.refId,
              '',
              '',
              type,

            );
          }
          // if current selected source is last object do nothing
        } else {
          // select prev source
          // if current selected source is first object, select the corresponding chain
          sources.some((source, index) => {
            if (source.id === selectedObject.id) {
              nextIndex = index - 1;
              return true;
            }
          });
          if (nextIndex !== -1) {
            var nextSource = sources[nextIndex];
            _setSelectedObject(
              nextSource.viewId,
              nextSource.id,
              nextSource.typeId,
              _.get(nextSource, "sourceData.Is Protected", "no"),
              SOURCE_TYPE
            );
          } else {
            var refPoints = this.refPoints;
            var selectRef = refPoints.filter(
              (r) => r.originalIndex === currentChainIndex
            );
            globalFunctions.updateReferencePoint[selectRef[0].viewId](true);
          }
        }
        break;
      case END_POINT_TYPE:
        var chains = this.props.object.chains;
        var currentChainIndex = -1;
        var currentChain = chains.filter((c, i) => {
          var selectedSource = c.sources.filter(
            (s) => s.viewId === selectedObject.viewId
          );
          if (selectedSource.length === 1) {
            currentChainIndex = i;
            return true;
          }
        });
        var lastSource = chains[currentChainIndex].sources[chains[currentChainIndex].sources.length - 1];
        _setSelectedObject(
          lastSource.viewId,
          lastSource.id,
          lastSource.typeId,
          _.get(lastSource, "sourceData.Is Protected", "no"),
          SOURCE_TYPE
        );
        break;
      case OPEN_POINT_TYPE:
        var chains = this.props.object.chains;
        var currentChainIndex = -1;
        var currentChain = chains.filter((c, i) => {
          var selectedSource = c.sources.filter(
            (s) => s.viewId === selectedObject.viewId
          );
          if (selectedSource.length === 1) {
            currentChainIndex = i;
            return true;
          }
        });
        var lastSource = chains[currentChainIndex].sources[chains[currentChainIndex].sources.length - 1];
        _setSelectedObject(
          lastSource.viewId,
          lastSource.id,
          lastSource.typeId,
          _.get(lastSource, "sourceData.Is Protected", "no"),
          SOURCE_TYPE
        );
        break;
    }
    var selectedObject = this.state.selectedObject;
    this.performPushReplaceState();
    this.scrollOnNavigation(selectedObject);
  }

  performPushReplaceState() {
    var objID = this.state.selectedObject.viewId;
    var objectID = objID.split('-');
    var mainObjUrl = {'objUrl' : objectID[0]};
    var lastSegment = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
    if(objectID[0] != lastSegment) {
      window.history.replaceState(window.location.href,'ObjURL',objID);
    } else {
      window.history.pushState(mainObjUrl,'Main',objID);
    }
  }

  scrollOnNavigation(selectedObject) {
    if (selectedObject.type == "SOURCE") {
      var chain_source = $("#show-object")
        .find(".selected-source")
        .closest(".chain-source");

      var outer = chain_source.parents(".simplebar-content");
      var target = chain_source; //Lets assume one element has the class active, it is the one we want to center
      var containerWidth = outer.width();
      var targetWidth = target.outerWidth(true);
      var targetIndex = chain_source.index(); //Tells us what position this is in. Useful in calculations

      // console.log(this.props.data.viewId, this.state.currentView, targetWidth, containerWidth)
      var leftScreenOffset = (containerWidth - targetWidth) / 2;
      var leftSiblingOffset = targetWidth * targetIndex;

      var scrollValue = leftSiblingOffset - leftScreenOffset;
      outer.scrollLeft(Math.max(0, scrollValue)); // our target is now centered
    }
  }

  changeLogOfSelectedObject() {
    const viewId = this.getSelectedObject("viewId");
    const type = this.getSelectedObject("type");
    const id = this.getSelectedObject("id");
    var changeLog = [];
    if (type === globalFunctions.objectTypes.OBJECT) {
      changeLog = this.props.object.changeLog.filter((change) => {
        if (change.fields && typeof change.fields.chainId !== "undefined") {
          return false;
        }
        return true;
      });
    } else if (type === globalFunctions.objectTypes.SOURCE) {
      this.props.object.chains.some((chain) => {
        return chain.sources.some((source) => {
          if (source.viewId === viewId) {
            changeLog = source.changeLog;
            return true;
          }
          return false;
        });
      });
    } else if (type === globalFunctions.objectTypes.REFERENCE_NO) {
      this.props.object.referencePoint.filter((value) => {
        if(value.changeLog.length && value.viewId === viewId) {
           changeLog = value.changeLog;
           return true;
        }else{
          return false;
        }
      });
    }
    return changeLog;
  }

  objectInfoOfSelectedObject() {
    const viewId = this.getSelectedObject("viewId");
    const type = this.getSelectedObject("type");
    const objectInfo = {};
    objectInfo.type = type;
    switch (type) {
      case globalFunctions.objectTypes.OBJECT:
        objectInfo.actualObjectData = Object.assign(
          {},
          this.props.object.actualObjectData
        );
        objectInfo.objectData = Object.assign({}, this.props.object.objectData);
        var keys = Object.keys(objectInfo.actualObjectData);
        delete objectInfo.actualObjectData[keys[keys.length - 1]];
        break;
      case globalFunctions.objectTypes.SOURCE:
        this.props.object.chains.some((chain) => {
          return chain.sources.some((source) => {
            if (source.viewId === viewId) {
              objectInfo.sourceData = Object.assign({}, source.sourceData);
              objectInfo.reference = Object.assign({}, source.reference);
              return true;
            }
            return false;
          });
        });
        break;
      case globalFunctions.objectTypes.REFERENCE:
        this.props.object.referencePoint.some((refPoint) => {
          if (refPoint.viewId === viewId) {
            objectInfo.referenceData = {};
            objectInfo.referenceData.viewId = refPoint.viewId;
            objectInfo.referenceData.title = refPoint.title;
            objectInfo.referenceData.value = refPoint.value;
            return true;
          }
          return false;
        });
        break;
    }
    return objectInfo;
  }


  getSelectedObject(key) {
    return this.state.selectedObject && this.state.selectedObject[key];
  }

  equalHeight(classNameSelector) {
    $(
      classNameSelector + " .left_col, " + classNameSelector + " .right_col"
    ).equalHeights();
    var sb = new SimpleBar($(classNameSelector).parents("[data-simplebar]")[0]);
    sb.recalculate();
    $(".content_box").find(".simplebar-content").addClass("dragscroll");
    dragscroll.reset();
  }

  afterFetchForm() {
    $().afterFetchFormSidebar(); //defined in app.js
    this.hideFormFields();
  }

  beforeFetchForm() {
    $().beforeFetchFormSidebar(); //defined in app.js
  }

  // earlier this function was defined in ChainObject.js but now
  // as save as favorite can be performed from info bar, i've moved this function here
  saveAsFavorite() {
    $("#save-as-favorite-menu-item").addClass("disabled");
    var data = { object_id: this.props.object.id };
    $.ajax({
      type: "post",
      url: site_url + "/chain/save_as_favorite",
      dataType: "json",
      data: data,
      success: function (response) {
        var message = response.message;
        var className = "";
        if (response.success) {
          globalFunctions.loadChain();
          className = "positive";
          message = "<p>" + message + "</p>";
        } else {
          className = "negative";
          message = response.message
            .split("<br>")
            .map((error) => "<li>" + error + "</li>")
            .join("");
        }
        var messageHTML =
          '<div id="message" class="ui ' +
          className +
          ' message">' +
          '<i class="close icon close-message"></i>' +
          message +
          "</div>";
        $("#show-object-container #message").remove();
        $(messageHTML).insertBefore("#show-object-container #show-object");
        $("#save-as-favorite-menu-item").removeClass("disabled");
      },
      error: function (jqxhr, status, exception) {
        //console.log(exception);
        //console.log(status);
        //console.log(jqxhr);
      },
    });
    // console.log("save as favorite ", this.props.object.id);
  }

  hideFormFields() {
    const {
      sourceCurrentInfo,
      sourceTypeId,
      sourceCurrentInfoData,
    } = this.state;
    let formElements = document.querySelectorAll("#object-form .field");
    let compareLength = 8; //sourceTypeId for Movie  = 4 , Event = 3, website = 6, 1 => article
    if (sourceTypeId === 1) {
      // compareLength = 12;
      compareLength = 9;
    } else if (sourceTypeId === 4) {
      compareLength = 14;
    } else if (sourceTypeId === 3) {
      compareLength = 7;
    } else if (sourceTypeId === 5) {
      compareLength = 4;
    } else if (sourceTypeId === 6) {
      compareLength = 0;
    } else if (sourceTypeId === 2) {
      compareLength = 11;
    } else if (sourceTypeId === 8) {
      compareLength = 12 + ($("#author-section input[class*='author-']").length);
    } else if (sourceTypeId === 9) {
      compareLength = 5;
    } else if (sourceTypeId === 10) {
      compareLength = 6;
    } else if (sourceTypeId === 11) {
      compareLength = 5;
    } else if (sourceTypeId === 12) {
      compareLength = 16;
    } else if (sourceTypeId === 13) {
      compareLength = 5;
    } else if (sourceTypeId === 14) {
      compareLength = 5;
    } else  if(sourceTypeId === null) {
      this.setState({ sourceCurrentInfoData: null });
    }
    
    var add_source = globalFunctions.getTranslatedMessage(
      this.dataI18nKeys[3],
      "Add source"
    );
    if ($("#title-form-object").html() === add_source) {
      compareLength = 0;
    }
    let filteredFormElements = [];
    formElements.forEach((e, index) => {
      if (!($(e).find(".ui.radio.checkbox").length === 1)) {
        filteredFormElements.push(e);
      }
    });
    
    if (!_.isEmpty(filteredFormElements)) {
      if (sourceCurrentInfoData === "OBJECT_DATA" && compareLength !== 0) {
        $('.source-reference-block').css('display','none');
        // if(sourceTypeId == 5) {
        //     $('.field-po-name').addClass('remove-provider-block');
        //     $('.field-po-name').removeClass('provider-block');
        // }
        if(sourceTypeId == 1 || sourceTypeId == 2 || sourceTypeId == 9 || sourceTypeId == 11 || sourceTypeId == 8) { 

          var ObjTitle = '';
          if(sourceTypeId == 1)
            ObjTitle = 'ObjArticle';
          else if(sourceTypeId == 2)
            ObjTitle = 'ObjBook';
          else if(sourceTypeId == 9)
            ObjTitle = 'ObjBlog';
          else if(sourceTypeId == 11)
            ObjTitle = 'ObjArticleWeb';
          else if(sourceTypeId == 8)
            ObjTitle = 'ObjEssay';

          $('.author-details').show()
          $('.addfield').show();
          $('.wrap-author').each((index) => {
            var firstName = $('input:text[name="'+ObjTitle+'[authorDetails]['+index+'][firstname]"]').val();
            var lastName = $('input:text[name="'+ObjTitle+'[authorDetails]['+index+'][lastname]"]').val();
            if(firstName == '' && lastName == ''){
              $('input:text[name="'+ObjTitle+'[authorDetails]['+index+'][firstname]"]').parent().remove();
            }
          })
        }
        let flag = 0;
        filteredFormElements.forEach((e, index) => {
          if (
            $(e).find("#objarticle-uploadedfile").length === 1 &&
            sourceTypeId === 1
          ) {
            e.style.display = "none";
            flag++;
            return false;
          } else if (flag > 0) {
            e.style.display = "none";
          } else if (index >= compareLength) {
            e.style.display = "none";
            $(e).parent('div').prev('label').css("display", "none")
            // this is temporary fix to hide devider dots
            if (
              $(e).hasClass("field-movie-time-ss") ||
              $(e).hasClass("field-movie-end-time-ss")
            )
              $(e).parent().hide();
          } else {
            e.style.display = "block";
            // this is temporary fix to hide devider dots
            if ($(e).hasClass("field-movie-length-ss")) $(e).parent().show();
          }

          if($(e).hasClass('field-essay-school-name')){
            if(parseInt($("#objessay-school_type").val()) > 0){
              e.style.display = "block";
            }else{
              e.style.display = "none";
            } 
          }
        });
      } else if (
        sourceCurrentInfoData === "OBJECT_REFERENCE" &&
        compareLength !== 0
      ) {
        $('.source-reference-block').css('display','block');
        // if(sourceTypeId == 5) {
        //     $('.field-po-name').addClass('provider-block');
        //     $('.field-po-name').removeClass('remove-provider-block');
        // }
        if(sourceTypeId == 1 || sourceTypeId == 2 || sourceTypeId == 9 || sourceTypeId == 11 || sourceTypeId == 8) { 
          $('.author-details').hide()
        }
        let flag = 0;
        filteredFormElements.forEach((e, index) => {
          if (
            $(e).find("#objarticle-uploadedfile").length === 1 &&
            sourceTypeId === 1
          ) {
            e.style.display = "block";
            flag++;
            return false;
          } else if (flag > 0) {
            e.style.display = "block";
          } else if (index < compareLength) {
            e.style.display = "none";
            // this is temporary fix to hide devider dots
            if ($(e).hasClass("field-movie-length-ss")) $(e).parent().hide();
          } else {
            e.style.display = "block";
            // this is temporary fix to hide devider dots
            if (
              $(e).hasClass("field-movie-time-ss") ||
              $(e).hasClass("field-movie-end-time-ss")
            )
              $(e).parent().show();
          }
        });
      } else {
        // if(sourceTypeId == 5) {
        //   $('.field-po-name').addClass('remove-provider-block');
        //   $('.field-po-name').removeClass('provider-block');
        // }
        if(sourceTypeId == 1 || sourceTypeId == 2 || sourceTypeId == 9 || sourceTypeId == 11 || sourceTypeId == 8) {
          $('.author-details').show();
          $('.addfield').show();
        }
        $('.source-reference-block').css('display','none'); // block
        filteredFormElements.forEach((e, index) => {
          e.style.display = "block";
        });
      }
    }

    var objmovie = $("#objmovie-type input").val();
    if (objmovie != 5) {
      $(".field-movie-url").addClass("hidden");
      $("#movie-url").addClass("hidden");
    } else {
      $(".field-movie-url").removeClass("hidden");
      $("#movie-url").removeClass("hidden");
    }

    var objarticle = $("#objarticle-type input").val();
    if (objarticle == 2) {
      $(".field-object-news-paper-name").addClass("hidden");
      $("#object-news-paper-name").addClass("hidden");
      $("#object-news-paper-name").val("");
    } else {
      $(".field-object-news-paper-name").removeClass("hidden");
      $("#object-news-paper-name").removeClass("hidden");
    }
  }

  fetchEditForm(id, viewId) {
    var data = { id: id };
    var prevSourceId = $("#object-form-container > #object-form")
      .find("[name=sourceId]")
      .val();
    var currentSourceId = this.getSelectedObject("viewId");
    this.hideFormFields();
    if (prevSourceId === currentSourceId) {
      return; // if sourceId has not changed, don't refresh the form
    }
    this.beforeFetchForm();
    $.ajax({
      type: "post",
      url: site_url + "/chain/fetch_edit_form",
      dataType: "json",
      data: data,
      success: (response) => {
        if (response.success) {
          $("#object-form-container > #title-form-object").text(
            response.title + " " + viewId
          );
          $("#object-form-container > #object-form").html(
            '<input type="hidden" name="objectId" value="' +
              id +
              '">' +
              '<input type="hidden" name="sourceId" value="' +
              currentSourceId +
              '">' +
              response.form +
              '<button class="ui button" id="edit-object" type="button">Submit</button>'
          );
          $("#objarticle-type").trigger("change");
          this.afterFetchForm();
        }
      },
      error: function (jqxhr, status, exception) {
        //console.log(exception);
        //console.log(status);
        //console.log(jqxhr);
      },
    });
    //return ('<button class="ui button" id="edit-object" type="button">Submit</button>');
  }

  createChain(e) {
    e.stopPropagation();
    var onResolved = (response) => {
      var extraInputs =
        '<input type="hidden" name="objectId" value="' +
        this.props.object.id +
        '">' +
        '<input type="hidden" name="referenceType" value="' +
        this.props.object.typeId +
        '">' +
        '<button id="add-chain" class="ui button" type="button">Add</button>';
      if (response.isForm) {
        var reference = globalFunctions.getTranslatedMessage(
          this.dataI18nKeys[4],
          "Reference"
        );
        $("#sub-title-form-object").html(reference);
        $("#object-form").html(response.data + extraInputs);
      } else {
        var select_type = globalFunctions.getTranslatedMessage(
          this.dataI18nKeys[6],
          "Select type"
        );
        // $("#sub-title-form-object").html("Type: " + (select_type === 'Article'? select_type : select_type));
        $("#sub-title-form-object").html((select_type === 'Article'? select_type : select_type));
        var types = JSON.parse(response.data);
        var html = Object.keys(types)
          .map(
            (key, index) =>
              '<div class="field">' +
              '<div class="ui radio checkbox">' +
              '<input type="radio" name="addSourceType"' +
              'value="' +
              types[key] +
              '"' +
              (index === 0 ? ' checked="checked"' : "") +
              ">" +
              "<label>" +
              key +
              "</label>" +
              "</div>" +
              "</div>"
          )
          .join("");
        $("#object-form").html(
          html +
            extraInputs +
            '<input type="hidden" value="1" name="directSource">'
        );
      }
      this.afterFetchForm();
    };

    var onRejected = (error) => {
      //console.log("error is ", error);
    };

    this.fetchChainForm(this.props.object.typeId).then(
      (value) => onResolved(value),
      (error) => onRejected(error)
    );
  }

  fetchChainForm(typeId, chainId = -1) {
    this.setState({ sourceCurrentInfoData: "" });
    this.beforeFetchForm();
    let objectId = this.props.object.id;
    var header_msg =
      chainId === -1
        ? globalFunctions.getTranslatedMessage(
            this.dataI18nKeys[5],
            "Add chain"
          )
        : "Edit chain";
    $("#title-form-object").html(header_msg);
    return new Promise(function (resolve, reject) {
      $.ajax({
        type: "post",
        url: site_url + "/chain/fetch_reference_form",
        data: { typeId: typeId, chainId: chainId, objectId: objectId, headerMsg: header_msg },
        dataType: "json",
        success: function (response) {
          resolve(response);
          // console.log("miral===");
          // console.log($("#objarticle-type input").val());
          // console.log(response);
        },
        error: function (jqxhr, status, exception) {
          //console.log("ajax error: /chain/fetch_reference_form");
          //console.log(exception);
          //console.log(status);
          //console.log(jqxhr);
          reject(true);
        },
      });
    });
  }

  addSource(id, viewId) {
    this.beforeFetchForm();
    var add_source = globalFunctions.getTranslatedMessage(
      this.dataI18nKeys[3],
      "Add source"
    );
    var select_type = globalFunctions.getTranslatedMessage(
      this.dataI18nKeys[6],
      "Select type"
    );
    $("#title-form-object").html(add_source);
    // $("#sub-title-form-object").html("Type: " + (select_type === 'Article'? select_type : select_type));
    $("#sub-title-form-object").html((select_type === 'Article'? select_type : select_type));
    this.selectNewObjectType(id, viewId).then((value) => {
      if (value) {
        this.afterFetchForm();
      }
    });
  }

  appendSource(refId, appendSourceId) {
    var data = { refId : refId, appendSourceId: appendSourceId};
    $.ajax({
      type: "post",
      url: site_url + "/chain/update_chain_status",
      dataType: "json",
      data: data,
      success: function (response) {
        $("html, body").animate({ scrollTop: 0 }, "slow", function () {
          if (typeof response.reload !== "undefined" && response.reload) {
            setTimeout(function () {
              location.reload();
            }, 1000);
            return;
          }
          globalFunctions.loadChain();
        });
      },
      error: function (jqxhr, status, exception) {
        //console.log(exception);
        //console.log(status);
        //console.log(jqxhr);
      },
    });
  }

  deleteEndPoint() {
    var content = globalFunctions.getTranslatedMessage(
      this.dataI18nKeys[1],
      "Are you sure "
    );

    content +=
      globalFunctions.getTranslatedMessage(
        this.dataI18nKeys[11],
        "you want to delete this "
      ) + (this.getSelectedObject("type") === 'OPEN_POINT' ? 'open point' : 
            (this.getSelectedObject("type") === 'END_POINT' ? 'end point' : '')
          ) +
      "? ";

    var header = globalFunctions.getTranslatedMessage(
      this.dataI18nKeys[2],
      "Delete object"
    );

    this.showDeleteModal(header, content, () => this.appendSource(this.getSelectedObject("id"), 0));
  }

  performDeleteObject(id) {
    $("#message").remove();
    var data = { id: id };
    $.ajax({
      type: "post",
      url: site_url + "/chain/delete_object",
      dataType: "json",
      data: data,
      success: function (response) {
        var className = response.success ? "positive" : "negative";
        $(
          '<div id="message" class="ui ' +
            className +
            ' message">' +
            '<i class="close icon close-message"></i>' +
            "<p>" +
            response.message +
            "</p>" +
            "</div>"
        ).insertBefore("#show-object-container #show-object");
        $("html, body").animate({ scrollTop: 0 }, "slow", function () {
          if (typeof response.reload !== "undefined" && response.reload) {
            setTimeout(function () {
              location.reload();
            }, 1000);
            return;
          }
          globalFunctions.loadChain();
        });
      },
      error: function (jqxhr, status, exception) {
        //console.log(exception);
        //console.log(status);
        //console.log(jqxhr);
      },
    });
  }

  performDeleteObjectType(id) {
    $("#message").remove();
    var data = { id: id };
    $.ajax({
      type: "post",
      url: site_url + "/chain/delete_main_object",
      dataType: "json",
      data: data,
      success: function (response) {
        var className = response.success ? "positive" : "negative";
        $(
          '<div id="message" class="ui ' +
            className +
            ' message">' +
            '<i class="close icon close-message"></i>' +
            "<p>" +
            response.message +
            "</p>" +
            "</div>"
        ).insertBefore("#show-object-container #show-object");
        $("html, body").animate({ scrollTop: 0 }, "slow", function () {
          if (typeof response.reload !== "undefined" && response.reload) {
            setTimeout(function () {
              location.reload();
            }, 1000);
            return;
          }
          globalFunctions.loadChain();
        });
      },
      error: function (jqxhr, status, exception) {
        //console.log(exception);
        //console.log(status);
        //console.log(jqxhr);
      },
    });
  }

  deleteObject(id, extraMessage = true) {  
    var content = globalFunctions.getTranslatedMessage(
      this.dataI18nKeys[1],
      "Are you sure?"
    );

    if (extraMessage) {
      content +=
        "<br>" +
        globalFunctions.getTranslatedMessage(
          this.dataI18nKeys[7],
          "Deleting source will lead to change of IDs of successive objects"
        ) +
        "!";
    }

    var header = globalFunctions.getTranslatedMessage(
      this.dataI18nKeys[2],
      "Delete object"
    );

    // alert(1151);
    if(this.state.selectedObject == null) {
        this.showDeleteModal(header, content, () => this.performDeleteObjectType(id));
    } else if(this.state.selectedObject != null) {
      if(this.state.selectedObject.type == 'OBJECT') {
        this.showDeleteModal(header, content, () => this.performDeleteObjectType(id));
      } else {
          this.showDeleteModal(header, content, () => this.performDeleteObject(id));
      }
    }
    
  }

  performDeleteChain(id) {
    $("#message").remove();
    var data = { id: id };
    $.ajax({
      type: "post",
      url: site_url + "/chain/delete_reference",
      dataType: "json",
      data: data,
      success: function (response) {
        var className = response.success ? "positive" : "negative";
        $(
          '<div id="message" class="ui ' +
            className +
            ' message">' +
            '<i class="close icon close-message"></i>' +
            "<p>" +
            response.message +
            "</p>" +
            "</div>"
        ).insertBefore("#show-object-container #show-object");
        $("html, body").animate({ scrollTop: 0 }, "slow", function () {
          globalFunctions.loadChain();
        });
      },
      error: function (jqxhr, status, exception) {
        //console.log(exception);
        //console.log(status);
        //console.log(jqxhr);
      },
    });
  }

  deleteChain(id) {
    var header = globalFunctions.getTranslatedMessage(
      this.dataI18nKeys[8],
      "Delete reference"
    );
    var content = globalFunctions.getTranslatedMessage(
      this.dataI18nKeys[1],
      "Are you sure?"
    );
    content +=
      "<br>" +
      globalFunctions.getTranslatedMessage(
        this.dataI18nKeys[9],
        "Deleting reference will remove all the sources from this chain too"
      );
    this.showDeleteModal(header, content, () => this.performDeleteChain(id));
  }

  showDeleteModal(header, content, onApprove) {
    $(".ui.modal#delete-object-modal")
      .modal({
        closable: false,
        centered: false,
        onApprove: onApprove,
        onShow: function () {
          $(".ui.modal#delete-object-modal .header").html(header);
          $(".ui.modal#delete-object-modal .content p").html(content);
        },
      })
      .modal("show");
  }

  selectNewObjectType(parentId, viewId) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "post",
        url: site_url + "/chain/fetch_object_types",
        data: {},
        dataType: "json",
        success: (types) => {
          // console.log("types = ", types);
          var html = Object.keys(types)
            .map(
              (key, index) =>
              types[key] !== 13 && types[key] !== 14 ?
                '<div class="field">' +
                '<div class="ui radio checkbox">' +
                '<input type="radio" name="selectType"' +
                'value="' +
                types[key] +
                '"' +
                (index === 0 ? ' checked="checked"' : "") +
                ">" +
                "<label>" +
                key +
                "</label>" +
                "</div>" +
                "</div>" : ""
              
            )
            .join(""); //add radio buttons

          html += '<p style="margin-bottom: 10px; font-weight: bold; color: rgba(0, 0, 0, 0.87)">Education</p>'; // added for education radio list
          html += Object.keys(types) 
            .map(
              (key, index) =>
              types[key] === 13 || types[key] === 14 ?
                '<div class="field">' +
                '<div class="ui radio checkbox">' +
                '<input type="radio" name="selectType"' +
                'value="' +
                types[key] +
                '"' +
                (index === 0 ? ' checked="checked"' : "") +
                ">" +
                "<label>" +
                key +
                "</label>" +
                "</div>" +
                "</div>" : ""
            )
            .join(""); //add radio buttons

          html +=
            '<input type="hidden" value="' +
            this.props.object.id +
            '" name="rootId">'; //add root id
          html +=
            '<input type="hidden" value="' + parentId + '" name="belongsTo">'; //add parent id
          html += '<input type="hidden" value="' + viewId + '" name="viewId">'; //add view id
          html +=
            '<div class="is-protected-wrap"><label for="is_protected">Is protected</label><div class="ui checkbox is_protected"><input id="is_protected" type="checkbox" name="is_protected"><label>Source Protected</label></div></div>';
          html +=
            '<button class="ui button" id="select-type" type="button">Submit</button>';

          $("#object-form").html(html);
          resolve(true);
        },
        error: function (jqxhr, status, exception) {
          //console.log("error");
          //console.log(exception);
          //console.log(status);
          //console.log(jqxhr);
        },
      });
    });
  }

  sortReferences() {
    var typeId = this.props.object.typeId;
    var refPoint = this.props.object.referencePoint
      .map(function (e, i) {
        return Object.assign(e, { originalIndex: i }); // original index stores the sorted index
      })
      .slice(); // clone array
    var comparatorFunction = globalFunctions.getComparatorFunction(typeId);
    if (!comparatorFunction) {
      return refPoint;
    }
    return refPoint.sort(comparatorFunction);
    // return refPoint;
  }

  toggleModal(
    value,
    header = "",
    content = null,
    footer = "",
    scrollHeight = 0,
    hideShareButton = true,
    url = "",
    archiveURL = ""
  ) {
    if (value) {
      // Modal open
      $("#mySidenav").css("z-index", "2");
      $("body").css({ height: "100vh", "overflow-y": "auto" });
    } else {
      // Modal Close
      $("#mySidenav").css("z-index", "3");
      $("body").css({ height: "", "overflow-y": "" });
    }
    this.setState(
      {
        showModal: value,
        modalHeader: header,
        modalContent: content,
        modalFooter: footer,
        hideShareButton: hideShareButton,
        url: url,
        sourcetype: this.state.sourceTypeId,
        archiveURL: archiveURL
      },
      () => {
        //console.log('content', content);
        if (value && scrollHeight > 0) {
          var src = content.props.src;
          var loaderImage = site_url + "/img/loading.gif";
          if ($("div#chain-modal div#content").length > 0) {
            $("div#chain-modal div#content").append(
              '<img id="scroll-loader" src="' +
                loaderImage +
                '" style="position: absolute;top: 50%;right: 50%;height: 100px;">'
            );
            $("div#chain-modal div#content").css("overflow", "hidden");
          }
          var realWidth, realHeight;
          $("<img/>")
            .attr("src", src)
            .on("load", function () {
              if ($("div#chain-modal div#content").length > 0) {
                $("div#chain-modal div#content").css("overflow", "");
                if ($("img#scroll-loader").length > 0) {
                  $("img#scroll-loader").remove();
                }
              }
              var realWidth = this.width;
              realHeight = this.height;

              var currentWidth = $(".uploaded-file").width();
              var percentage = (currentWidth * 100) / realWidth;

              scrollHeight = (scrollHeight * percentage) / 100;
              scrollHeight =
                scrollHeight - $(".chain-modal-header").outerHeight(true);
              $("#content").animate({ scrollTop: scrollHeight }, "slow");
              
            });

            if ($("img#scroll-loader").length > 0) {
              $("img#scroll-loader").remove();
            }
        }
      }
    );
  }

  toggleModalCloseIcon(value) {
    // console.log("in toggle modal close icon")
    this.setState({
      hideModalCloseIcon: value,
    });
  }

  selectedChainIsPersonalOpinion() {
    if (this.state.selectedObject === null) {
      return null; // currently no object is selected
    }
    if (
      this.state.selectedObject.type !==
        globalFunctions.objectTypes.REFERENCE &&
      this.state.selectedObject.type !==
        globalFunctions.objectTypes.REFERENCE_NO
    ) {
      return -1; // not reference
    }
    if (
      this.state.selectedObject.type ===
        globalFunctions.objectTypes.REFERENCE ||
      this.state.selectedObject.type ===
        globalFunctions.objectTypes.REFERENCE_NO
    ) {
      if (this.props.object.typeId === 5) {
        return 1; // reference and personal opinion
      }
      return 0; // reference but not personal opinion
    }
  }

  editFormInfoBar() {
    var onChainFormResolved = (response) => {
      var extraInputs =
        '<input type="hidden" name="objectId" value="' +
        this.props.object.id +
        '">' +
        '<input type="hidden" name="referenceType" value="' +
        this.props.object.typeId +
        '">' +
        '<input type="hidden" name="chainId" value="' +
        this.state.selectedObject.id +
        '">' +
        '<button id="add-chain" class="ui button" type="button">Update</button>';
      if (response.isForm) {
        var reference = globalFunctions.getTranslatedMessage(
          this.dataI18nKeys[4],
          "Reference"
        );
        $("#sub-title-form-object").html(reference);
        $("#object-form").html(response.data + extraInputs);
      }
      this.afterFetchForm();
    };
    var isPO = this.selectedChainIsPersonalOpinion();
    return isPO !== null // an object is selected
      ? isPO === -1 // not reference
        ? () =>
            this.fetchEditForm(
              this.state.selectedObject.id,
              this.state.selectedObject.viewId
            )
        : isPO === 1 // reference and personal opinion
        ? () => undefined
        : () =>
            this.fetchChainForm(
              this.props.object.typeId,
              this.state.selectedObject.id
            ).then(onChainFormResolved, (rejected) =>
              console.log("Rejected = ", rejected)
            )
      : () => undefined;
  }

  deleteObjectInfoBar() {
    var isPO = this.selectedChainIsPersonalOpinion();
    var selectedSourceType = this.getSelectedObject("type");
    return isPO !== null // an object is selected
      ? isPO === -1 // not reference
        ? (selectedSourceType !== globalFunctions.objectTypes.OPEN_POINT && selectedSourceType !== globalFunctions.objectTypes.END_POINT) ?
            () =>
            this.deleteObject(
              this.state.selectedObject.id,
              this.state.selectedObject.type ===
                globalFunctions.objectTypes.SOURCE
            )
            : () => this.deleteEndPoint()
        : () => this.deleteChain(this.state.selectedObject.id)
      : () => undefined;
  }

  horizontalArrowClick(e) {
    e.stopPropagation();
  }

  generateChainObject(isOwner, selectedSourceType) {
    return (
      <ChainObject 
        object={this.props.object}
        applyNoAfter={false}
        isOwner={isOwner}
        fetchEditFormMenu={this.editFormInfoBar()}
        fetchForm={this.fetchEditForm}
        afterFetchForm={this.afterFetchForm}
        beforeFetchForm={this.beforeFetchForm}
        delete={this.deleteObjectInfoBar()}
        selectedObject={this.state.selectedObject}
        setSelectedObject={this.setSelectedObject}
        selectedObjectId={
          selectedSourceType === globalFunctions.objectTypes.OBJECT
            ? this.getSelectedObject("viewId")
            : -1
        }
        saveAsFavorite={this.saveAsFavorite}
        showModal={(header, content = null) =>
          this.toggleModal(true, header, content)
        }
        isLoggedIn ={this.props.object.isLoggedIn}
      />
    );
  }

  contentBoxClicked(e, viewId, isChildSourceSelected) {
    e.stopPropagation();
    if (isChildSourceSelected) {
      return;
    }
    // refer app.js for below if condition
    if (globalFunctions.isDrag) {
      // console.log("since we are dragging we will not select the reference point");
      globalFunctions.isDrag = false;
      return;
    }
    // console.log("content box clicked", isChildSourceSelected, e.target);
    globalFunctions.updateReferencePoint[viewId]();
  }

  referencePointMouseEnter(viewId) {
    this.setState({
      leftBar: {
        show: true,
        color: "#b3b3b3",
        viewId: viewId,
      },
    });
  }

  referencePointMouseLeave(e) {
    this.setState({
      leftBar: this.initLeftBar,
    });
  }

  showLeftBar(show, refViewId) {
    if (show) {
      return <div className="show-source-selection" />;
    }
    if (refViewId === this.state.leftBar.viewId) {
      return <div className="show-ref-point-hover" />;
    }
  }

  setChainContainerState(data) {
    //console.log('setChainContainerState data', data);
    this.setState({ sourceCurrentInfoData: data.sourceCurrentInfo }, () => {});
    this.setState(data);
  }

  render() {
    // console.log('selectedObject', this.state.selectedObject);
    var chains = this.props.object.chains;
    var isOwner = this.props.object.isOwner;
    this.refPoints = this.sortReferences();
    var refPoint = this.refPoints;
    var objectTypeInitials =
      this.props.object.type
        .split(" ")
        .map((word) => word.substring(0, 1))
        .join("") + " - ";
    var selectedSourceId = this.getSelectedObject("id");
    var selectedSourceType = this.getSelectedObject("type");
    // console.log(this.props.object);
    return (
      <div
        className="main-wrapper"
        onClick={(e) =>{ 
        this.setSelectedObject(null);
        this.setState((state) =>( {
          isReferenceExpanded : false,
          isReferenceNumberExpanded : false,
          isSourceExpanded : false
        }));}}
      >
        <input type="hidden" name="selected_source_type" id="selected_source_type_hidden" value={selectedSourceType} />
        <div className="left-section">
          {refPoint.length === 0 && (
            <div className={"section-0 content_box"}>
              <div data-simplebar>
                <div className={"section-0"}>
                  <div className="left_col only-main-object">
                    {this.generateChainObject(isOwner, selectedSourceType)}
                    {refPoint.length === 0 && this.props.object.isOwner && (
                      <div id="create-chain">
                        <div className="btn-block">
                          {this.createChainButton}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          {refPoint.map((ref, index) => {
            var originalIndex = ref.originalIndex;
            var isSourceInChain =
              chains[originalIndex].sources
                .map((s) => s.id)
                .indexOf(selectedSourceId) !== -1;
            var selectedObject = selectedSourceType === globalFunctions.objectTypes.SOURCE
                                    ? this.getSelectedObject("viewId")
                                    : -1
            return (
              <div
                className={"section-" + index + " content_box"}
                key={originalIndex}
                // onClick={(e) =>
                //   this.contentBoxClicked(e, ref.viewId, isSourceInChain)
                // }
              >
                {/* <div className="next_arrow" onClick={this.horizontalArrowClick} >
                            <img src={site_url + "/img/horizontal_scroll_arrow.svg"} />
                        </div>
                        <div className="prev_arrow" onClick={this.horizontalArrowClick}>
                            <img src={site_url + "/img/horizontal_scroll_arrow.svg"} />
                        </div> */}
                <div data-simplebar>
                  <div
                    className={"section-" + index}
                    onMouseEnter={(e) =>
                      this.referencePointMouseEnter(ref.viewId)
                    }
                    onMouseLeave={this.referencePointMouseLeave}
                  >
                    <div className={((refPoint.length-1 == chains[originalIndex].sources.length && chains[originalIndex].sources.length == index) || refPoint.length-1 == 0) && selectedObject == -1 ? "left_col" : "left_col" }>
                      {index === 0 &&
                        this.generateChainObject(isOwner, selectedSourceType)}
                      <ReferencePoint
                        // title={ref.title || objectTypeInitials }
                        title={ref.title}
                        startPage={ref.title === 'Date Time' ? ref.value : ref.title != 'Section' ? ref.value : ''}
                        endPage={ref.title === 'Time' ? ref.end_time : ref.title === 'Date Time' ? ref.end_date_time ? ref.end_date_time : '-' : ref.end_page_number}
                        startSection={ref.section_number}
                        endSection={ref.end_section_number}
                        numberSingle={ref.number_single}
                        value={ref.title === 'Date Time' ? ref.value : ref.value || originalIndex + 1}
                        sectionNumber={ref.section_number}
                        id={ref.viewId || ""}
                        expandDiv={1}
                        sourceCount={chains[originalIndex].sources.length}
                        isOwner={isOwner}
                        setSelectedObject={this.setSelectedObject}
                        setIsExpandedFlag={this.setIsExpandedFlag}                        
                        isReferenceExpanded ={this.state.isReferenceExpanded}
                        isReferenceNumberExpanded ={this.state.isReferenceNumberExpanded}
                        selectedObjectId={
                          selectedSourceType ===
                            globalFunctions.objectTypes.REFERENCE ||
                          selectedSourceType ===
                            globalFunctions.objectTypes.REFERENCE_NO ||
                          selectedSourceType ===
                            globalFunctions.objectTypes.SOURCE
                            ? this.getSelectedObject("viewId")
                            : -1
                        }
                        fetchEditFormMenu={this.editFormInfoBar()}
                        fetchForm={this.fetchEditForm}
                        afterFetchForm={this.afterFetchForm}
                        beforeFetchForm={this.beforeFetchForm}
                        delete={this.deleteObjectInfoBar()}
                        selectedObjectType={selectedSourceType}
                        dbId={ref.refId}
                        key={ref.refId}
                        show={isSourceInChain}
                        object={this.props.object}
                        // selectedObject={this.state.selectedObject}
                        showModal={(header, content = null) =>
                          this.toggleModal(true, header, content)
                        }
                        selectedObject={this.state.selectedObject}
                        isLoggedIn ={this.props.object.isLoggedIn}
                      />
                      <i className="right-arrow" />
                      {
                        //this.showLeftBar(selectedSourceId === ref.refId || isSourceInChain, ref.viewId) // deactivate left bar as it has issue
                      }
                      {index === 0 && isOwner && (
                        <div id="create-chain">
                          <div className="btn-block">
                            {this.createChainButton}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className={((refPoint.length-1 == chains[originalIndex].sources.length && chains[originalIndex].sources.length == index) || refPoint.length-1 == 0) && selectedObject == -1 ? "right_col" : "right_col" } >
                      <div className={"section-" + index + " inner-line"}>
                        <div className="ui grid">
                          {chains[originalIndex] &&
                            chains[originalIndex].sources.map((source, i) => (
                              <ChainSource
                                key={"index-" + source.id}
                                data={source}
                                object={this.props.object}
                                isVoteable={this.props.object.isVoteable}
                                isOwner={this.props.object.isOwner}
                                totalSources={
                                  chains[originalIndex].sources.length
                                }
                                index={i + 1}
                                lastObject={refPoint.length-1}
                                classNameSelector={".section-" + index}
                                makeHeightsEqual={this.equalHeight}
                                fetchEditFormMenu={this.editFormInfoBar()}
                                fetchForm={this.fetchEditForm}
                                afterFetchForm={this.afterFetchForm}
                                beforeFetchForm={this.beforeFetchForm}
                                delete={this.deleteObjectInfoBar()}
                                setSelectedObject={this.setSelectedObject}
                                selectedObjectId={
                                  selectedSourceType ===
                                  globalFunctions.objectTypes.SOURCE
                                    ? this.getSelectedObject("viewId")
                                    : -1
                                }
                                showUploadFormModal={(header, content = null) =>
                                  this.toggleModal(true, header, content)
                                }
                                showSnapshotModal={(header, content, footer) =>
                                  this.toggleModal(
                                    true,
                                    header,
                                    content,
                                    footer
                                  )
                                }
                                showUploadedImage={(
                                  header,
                                  content,
                                  scrollHeight,
                                  hideShareButton,
                                  url,
                                  archiveURL
                                ) =>
                                  this.toggleModal(
                                    true,
                                    header,
                                    content,
                                    "",
                                    scrollHeight,
                                    hideShareButton,
                                    url,
                                    archiveURL
                                  )
                                }
                                toggleModalCloseIcon={this.toggleModalCloseIcon}
                                closeModal={() => this.toggleModal(false)}
                                expand={
                                  // selectedSourceId === ref.refId ||
                                  // isSourceInChain
                                  true
                                }
                                setChainContainerState={
                                  this.setChainContainerState
                                }
                                sourceCurrentInfo={this.state.sourceCurrentInfo}
                                sourceTypeId={this.state.sourceTypeId}
                                setIsExpandedFlag={this.setIsExpandedFlag}                        
                                isReferenceExpanded ={this.state.isReferenceExpanded}
                                isReferenceNumberExpanded ={this.state.isReferenceNumberExpanded}
                                appendStatus={ref.ref_chain_status == 0 || ref.ref_chain_status == null ? 'SourcePoint' : ref.ref_chain_status == 1 ? globalFunctions.objectTypes.OPEN_POINT : globalFunctions.objectTypes.END_POINT}
                                showModal={(header, content = null) =>
                                  this.toggleModal(true, header, content)
                                }
                                selectedObject={this.state.selectedObject}
                                isLoggedIn ={this.props.object.isLoggedIn}
                              />
                            ))}
                          {this.props.object.isOwner && chains[originalIndex].sources.length == 0 && (
                            <AddSource
                              parentId={ref.id}
                              viewId={ref.viewId + "-" + ref.newSource}
                              addSource={this.addSource}
                            />
                          )}
                          {chains[originalIndex].sources.length > 0 && (
                            <AppendSource
                              parentId={ref.id}
                              refId={ref.refId}
                              viewId={ref.viewId}
                              newSourceViewId={ref.viewId + "-" + ref.newSource}
                              appendSource={this.appendSource}
                              addSource={this.addSource}
                              lastSourceIndex={chains[originalIndex].sources.length}
                              appendStatus={ref.ref_chain_status == 0 || ref.ref_chain_status == null ? 'SourcePoint' : ref.ref_chain_status == 1 ? globalFunctions.objectTypes.OPEN_POINT : globalFunctions.objectTypes.END_POINT} 
                              setSelectedObject={this.setSelectedObject}
                              selectedObjectType={selectedSourceType}
                              isOwner = {this.props.object.isOwner}
                              lastSourceViewId = {chains[originalIndex].sources[chains[originalIndex].sources.length - 1].viewId}
                              isLoggedIn ={this.props.object.isLoggedIn}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="right-section"></div>
        <InfoBar
          selectedObject={this.state.selectedObject}
          showModal={(header, content = null) =>
            this.toggleModal(true, header, content)
          }
          changeLog={this.changeLogOfSelectedObject()}
          fetchEditForm={this.editFormInfoBar()}
          objectInfo={this.objectInfoOfSelectedObject()}
          hideEdit={
            !this.props.object.isOwner ||
            this.selectedChainIsPersonalOpinion() === 1
          }
          isOwner={isOwner}
          isLoggedIn={this.props.object.isLoggedIn}
          performDelete={this.deleteObjectInfoBar()}
          saveAsFavorite={this.saveAsFavorite}
          isSavedAsFavorite={this.props.object.isSavedAsFavorite}
        />

        <InfoBarHeader
          selectedObject={this.state.selectedObject}
          showModal={(header, content = null) =>
            this.toggleModal(true, header, content)
          }
          changeLog={this.changeLogOfSelectedObject()}
          fetchEditForm={this.editFormInfoBar()}
          objectInfo={this.objectInfoOfSelectedObject()}
          hideEdit={
            !this.props.object.isOwner ||
            this.selectedChainIsPersonalOpinion() === 1
          }
          isOwner={isOwner}
          isLoggedIn={this.props.object.isLoggedIn}
          performDelete={this.deleteObjectInfoBar()}
          saveAsFavorite={this.saveAsFavorite}
          isSavedAsFavorite={this.props.object.isSavedAsFavorite}
          isPublished={this.props.object.actualObjectData.is_published}
        />
        {this.state.showModal && (
          <Modal
            id="chain-modal"
            content={this.state.modalContent}
            header={this.state.modalHeader}
            footer={this.state.modalFooter}
            hideModal={() => this.toggleModal(false)}
            hideModalCloseIcon={this.state.hideModalCloseIcon}
            hideShareButton={this.state.hideShareButton}
            url={this.state.url}
            sourceType={this.state.sourcetype}
            archiveURL={this.state.archiveURL}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/web/js/ChainContainer.js